import { keyBy, difference, isEmpty, orderBy } from 'lodash';

export const sortOfferMechanicPresetsByPriority = (
    presets,
    priorityOrder,
    { sortRemainingByOrder = true } = {}
) => {
    if (!sortRemainingByOrder && isEmpty(priorityOrder)) {
        return presets;
    }

    const presetsByKey = keyBy(presets, 'offerTemplate');
    const allKeys = presets.map(p => p.offerTemplate);
    const remainingKeys = difference(allKeys, priorityOrder || []);

    // Prioritised keys that exist, followed by remaining keys
    const sortedKeys = [
        ...(priorityOrder || []).filter(key => presetsByKey[key]),
        ...remainingKeys,
    ];

    const prioritizedCount = isEmpty(priorityOrder)
        ? 0
        : (priorityOrder || []).filter(key => presetsByKey[key]).length;
    if (!sortRemainingByOrder) {
        return sortedKeys.map(key => presetsByKey[key]);
    }
    // orderBy is stable, so presets with equal sortOrder keep their stored (config) order.
    return [
        ...sortedKeys.slice(0, prioritizedCount).map(key => presetsByKey[key]),
        ...orderBy(
            sortedKeys.slice(prioritizedCount).map(key => presetsByKey[key]),
            [preset => preset.sortOrder || 0],
            ['asc']
        ),
    ];
};

export default { sortOfferMechanicPresetsByPriority };
